module.exports = __webpack_public_path__ + "img/influx.7b26d456.jpg";